import { useQuery } from '@tanstack/react-query';
import {
  fetchDeployments,
  fetchEnvironments,
  fetchLatestDeployments,
} from '@/api/deployments';
import type { DeploymentListParams } from '@/api/deployments';

export function useDeployments(params?: DeploymentListParams) {
  return useQuery({
    queryKey: ['deployments', params],
    queryFn: () => fetchDeployments(params),
    staleTime: 30 * 1000,
  });
}

export function useEnvironments() {
  return useQuery({
    queryKey: ['environments'],
    queryFn: fetchEnvironments,
    staleTime: 10 * 60 * 1000,
  });
}

export function useLatestDeployments() {
  return useQuery({
    queryKey: ['latest-deployments'],
    queryFn: fetchLatestDeployments,
    staleTime: 30 * 1000,
  });
}
